// First-run routes in the native app: onboarding, the welcome screen ("/" or
// a redirect from it), and the account and sign-in routes that come before
// Home. The fallback ATT request waits while a member is on one (new members
// get the prompt from onboarding v3's "How it works" screen instead), and so
// does opening an AppsFlyer deferred deep link.
const FIRST_RUN_EXACT_PATHS = new Set(['/']);
const FIRST_RUN_PATH_PREFIXES = [
  '/onboarding',
  '/dev/onboarding-v3',
  '/complete-account',
  '/auth',
  '/check-email',
  '/login',
  '/signup',
  '/reset-password',
  '/forgot-password',
];

export function isFirstRunTrackingDeferredPath(pathname: string): boolean {
  const normalized = (pathname.replace(/\/+$/, '') || '/').toLowerCase();
  if (FIRST_RUN_EXACT_PATHS.has(normalized)) return true;
  return FIRST_RUN_PATH_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`)
  );
}
